import {
    inject,
    observer
} from 'mobx-react'
import {
    WeaTop,
    WeaRightMenu
} from 'ecCom'

import RadioGroup from './RadioGroup';
import BarCharts from './BarCharts';
import TabsWp from './TabsWp';
import Footnote from './Footnote';

@inject('hrmApplicant') //todo
@observer
export default class Top extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.hrmApplicant.getMenus();
    }

    render() {
        const {
            hrmApplicant
        } = this.props, {
            top,
            menus,
            radioGroup,
            barCharts,
            tabs,
        } = hrmApplicant, {
            title,
        } = top, {　　
            buttons,
            dropMenuDatas,
        } = menus;

        return (
            <WeaTop 
                title={title}
                icon={<i className='icon-coms-hrm'/>}
                iconBgcolor='#217346'
                loading={radioGroup.loading || barCharts.loading || tabs.loading}
                buttons={buttons}
                showDropIcon={true}
                dropMenuDatas={dropMenuDatas}
            >
                <WeaRightMenu 
                    datas={dropMenuDatas}
                    collectParams={{favname: title,favouritetype:5}}
                >
                    <RadioGroup />
                    <BarCharts />
                    <TabsWp />
                    <Footnote />
                </WeaRightMenu>
            </WeaTop>
        )
    }

}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/components/applicant/Top.js